import { codeSplit } from 'bernie-core';

// export const MediaStudioSeriesPromoComponentMap = codeSplit(
export const MediaCarouselComponentMap = codeSplit(
  () => import(/* webpackChunkName: "Media-Carousel-component" */ '../media-carousel-module') as any
);
